var _circle, _path, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmsCost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    fill: "white",
    stroke: "#D8E8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9891 16.5H17.5109C16.6463 16.501 15.8175 16.8449 15.2062 17.4562C14.5949 18.0675 14.251 18.8963 14.25 19.7609V34.1087C14.251 34.9732 14.5949 35.802 15.2062 36.4134C15.8175 37.0247 16.6463 37.3685 17.5109 37.3696H18.8152V42.5577C18.8128 42.8235 18.8904 43.0839 19.0379 43.3051C19.1855 43.5262 19.3962 43.6979 19.6426 43.7977C19.8811 43.894 20.1431 43.9161 20.3944 43.8612C20.6457 43.8063 20.8746 43.677 21.0513 43.4901L26.9197 37.3696H40.9891C41.8537 37.3685 42.6825 37.0247 43.2938 36.4134C43.9051 35.802 44.249 34.9732 44.25 34.1087V19.7609C44.249 18.8963 43.9051 18.0675 43.2938 17.4562C42.6825 16.8449 41.8537 16.501 40.9891 16.5ZM42.9457 34.1087C42.9451 34.6274 42.7388 35.1247 42.372 35.4915C42.0052 35.8583 41.5079 36.0646 40.9891 36.0652H26.6413C26.5534 36.0652 26.4664 36.083 26.3855 36.1175C26.3046 36.152 26.2315 36.2024 26.1706 36.2658L20.1196 42.5577V36.7174C20.1196 36.6317 20.1028 36.5469 20.07 36.4678C20.0373 36.3886 19.9892 36.3167 19.9287 36.2561C19.8681 36.1955 19.7962 36.1475 19.717 36.1148C19.6379 36.082 19.5531 36.0652 19.4674 36.0652H17.5109C16.9921 36.0646 16.4948 35.8583 16.128 35.4915C15.7612 35.1247 15.5549 34.6274 15.5543 34.1087V19.7609C15.5549 19.2421 15.7612 18.7448 16.128 18.378C16.4948 18.0112 16.9921 17.8049 17.5109 17.8043H40.9891C41.5079 17.8049 42.0052 18.0112 42.372 18.378C42.7388 18.7448 42.9451 19.2421 42.9457 19.7609V34.1087Z",
    fill: "#4D5152"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 22.5,
    width: 13.5,
    height: 1.5,
    rx: 0.75,
    fill: "#51ACFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 26.25,
    width: 20.25,
    height: 1.5,
    rx: 0.75,
    fill: "#51ACFC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 30,
    width: 20.25,
    height: 1.5,
    rx: 0.75,
    fill: "#51ACFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsCost);
export default __webpack_public_path__ + "static/media/sms-cost.ccbe9864a7b477d9ec26f85152e906cb.svg";
export { ForwardRef as ReactComponent };